const { include } = require('named-urls');

module.exports = {
  auth: include('/auth', {
    forgotPassword: 'forgot-password',
    resetPassword: 'reset-password/:token',
    signIn: 'sign-in',
    signOut: 'sign-out',
    signUp: 'sign-up',
    talkSso: 'talk-sso',
    welcome: 'welcome/:userUuid',
  }),
  enroll: include('/enroll/:code', {
    prefix: '',
    overview: 'overview',
    purchase: 'purchase',
  }),
  magic: '/magic/:data',

  // 20190923JP: Deprecated, use study.* instead.
  product: include('/products/:productSlug', {
    content: 'content/:contentUuid',
    dashboard: 'dashboard',
    exam: 'exams/:userExamUuid',
    exams: 'exams',
    feedback: 'feedback',
    learn: 'learn/:contentUuid',
    overview: 'overview',
    review: 'review',
    rewards: 'rewards',
    subscription: 'subscription',
  }),
  redeem: '/redeem',
  study: include('/study/:productSlug', {
    account: 'account',
    catalog: 'catalog',
    content: 'content/:contentUuid',
    dashboard: 'dashboard',
    essay: 'essay/:essayResponseUuid',
    exam: 'exams/:userExamUuid',
    exams: 'exams',
    feedback: 'feedback',
    learn: 'learn/:contentUuid',
    overview: 'overview',
    purchase: 'purchase',
    quiz: 'quiz/:quizCode',
    resources: 'resources',
    review: 'review',
    rewards: 'rewards',
    search: 'search',
    subscription: 'subscription',
    tutoring: 'tutoring',
  }),

  staff: include('/staff', {
    prefix: '',
    charges: ':partnerSlug/charges',
    dashboard: 'dashboard',
    organizations: 'organizations',
    organization: include('organizations/:organizationUuid', {
      overview: 'overview',
    }),
    products: 'products',
    product: include('products/:productSlug', {
      overview: 'overview',
      content: include('content', {
        overview: '',
        edit: ':contentUuid',
      }),
      flashcards: 'flashcards',
    }),
    grants: 'grants',
    promoCodes: 'promo-codes',
    system: 'system',
    users: 'users',
  }),
  studyReport: include('/study-report/:userUuid/:productSlug', {
    overview: '',
  }),
};
